import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["enabled", "children", "side", "styles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import { uniqueId } from '../../lib/uniqueId.js';
import { applyStylingHoc } from '../../lib/styling.js';
import baseStyles from './OffCanvas.scss';
import Content from './Content.js';
export var OffCanvas = /*#__PURE__*/function (_PureComponent) {
  _inherits(OffCanvas, _PureComponent);

  var _super = _createSuper(OffCanvas);

  function OffCanvas() {
    var _this;

    _classCallCheck(this, OffCanvas);

    _this = _super.apply(this, arguments);

    _this.setMenu = function (node) {
      _this._menu = node;
    };

    _this.handleStateChange = function (_ref) {
      var isOpen = _ref.isOpen;
      var _this$props = _this.props,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          onEnter = _this$props.onEnter,
          onEntered = _this$props.onEntered,
          addBodyClassOnOpen = _this$props.addBodyClassOnOpen,
          openedBodyClass = _this$props.openedBodyClass;

      if (!isOpen) {
        if (addBodyClassOnOpen && window.document.body) {
          window.document.body.classList.remove(openedBodyClass);
        }

        if (onExit) {
          onExit();
        }

        if (onExited) {
          onExited();
        }
      } else {
        if (addBodyClassOnOpen && window.document.body) {
          window.document.body.classList.add(openedBodyClass);
        }

        if (onEnter) {
          onEnter();
        }

        if (onEntered) {
          onEntered();
        }
      }
    };

    return _this;
  }

  _createClass(OffCanvas, [{
    key: "handleToggleMenu",
    value: function handleToggleMenu() {
      if (this._menu) {
        this._menu.toggleMenu();
      }

      if (this.props.addBodyClassOnOpen && window.document.body) {
        window.document.body.classList.toggle(this.props.openedBodyClass);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          enabled = _this$props2.enabled,
          children = _this$props2.children,
          side = _this$props2.side,
          styles = _this$props2.styles,
          rest = _objectWithoutProperties(_this$props2, _excluded);

      var id = uniqueId();
      var outerContainerId = this.props.outerContainerId || 'outer-container-' + id;
      return React.createElement("div", {
        className: styles.root,
        id: outerContainerId
      }, enabled && React.createElement(Content, _objectSpread(_objectSpread({}, rest), {}, {
        right: side === 'right',
        ref: this.setMenu,
        outerContainerId: outerContainerId,
        innerId: id,
        onStateChange: this.handleStateChange,
        styles: styles.content
      }), children));
    }
  }]);

  return OffCanvas;
}(PureComponent);
OffCanvas.defaultProps = {
  side: 'left',
  enabled: true,
  addBodyClassOnOpen: true,
  openedBodyClass: 'has-offcanvas',
  styles: {}
};
export default applyStylingHoc(baseStyles)(OffCanvas);